import { useMediaDownload } from "@/api/media";
import { useRFS } from "@/api/rfs";
import { swalError, swalLoading } from "@/utils/lib/swal";

export default function useDownloadABDKmz({ id }: { id?: string }) {
  if (!id) {
    throw new Error("Missing ID in route");
  }

  const { data: rfs } = useRFS({ id });
  const { mutate, isPending } = useMediaDownload();

  function handleDownload() {
    if (!rfs?.documentAbd) {
      return;
    }
    swalLoading.fire();

    mutate(
      {
        path: rfs.documentAbd,
        fileName: `ABD_${rfs?.clusterId}.kmz`,
      },
      {
        onSuccess: () => {
          swalLoading.close();
        },
        onError: () => {
          swalError.fire({
            text: "Failed to download ABD.kmz",
          });
        },
      },
    );
  }

  return { handleDownload, isPending };
}
